<div class="p-p-2">
    <span class="p-float-label">
        <p-multiSelect appendTo="body" [options]="options" [(ngModel)]="selectedItems" [filter]="filter"
            [disabled]="disabled" (onChange)="onSelectionChange($event)">
            <ng-template let-item pTemplate="selectedItem">
                <span>{{item.label}}</span>
            </ng-template>
            <ng-template let-opt pTemplate="item">
                <div>
                    <div>{{opt.label}}</div>
                </div>
            </ng-template>
        </p-multiSelect>
        <label for="field-id">{{label | translate}}</label>
    </span>
</div>